import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserJourneyService } from '../../_services/user-journey.service';
import { UserGradeService } from '../../_services/user-grade.service';

@Component({
  selector: 'app-simulations-info-modal',
  templateUrl: './simulations-info-modal.component.html',
  styleUrls: ['./simulations-info-modal.component.scss'],
})
export class SimulationsInfoModalComponent implements OnInit {

  module;
  userGrade;
  gradeSettings;
  protected isDemo: boolean;
  protected score: number;

  constructor(public modalCtrl: ModalController, private userJourneyService: UserJourneyService, private userGradeService: UserGradeService) { }

  async ngOnInit() {
    this.userGrade = await this.userJourneyService.getUserGrade(this.module);
    this.gradeSettings =  (await this.userJourneyService.getSimulationProgressSetting()).avatar
      .find(x => x.userGrade === this.userGrade);
    this.isDemo = await this.userJourneyService.isDemo();
    this.score = (await this.userJourneyService.getSimulationProgressSetting()).score;
  }

}
